<template>
  <div v-if="renderComponent">
    <div>
      <h5 class="vue-title pull-left header">
        <strong>{{ $t("PARTNERMASTER") }}</strong>
      </h5>
      <p
        class="float-right add-button"
        v-if="checkPermisssion('MASTER', 'MASTER_PARTNER_CATEGORY')"
      >
        {{ $t("ADD") }}
        <a href="#/addpartner">
          <em class="fas fa-plus-circle"></em>
        </a>
      </p>
      <b-input-group
        class="pull-right search-box search-text-box"
      >
        <template v-slot:prepend>
          <b-input-group-text @click="onSerach">
            <em class="fa fa-search"></em>
          </b-input-group-text>
        </template>
        <b-form-input
          size="sm"
          @keyup.enter="onSerach"
          autocomplete="off"
          v-model="searchKeyword"
        ></b-form-input>
      </b-input-group>
    </div>

    <c-table
      :table-data="partnerMasterList.list"
      :fields="tableHeader"
      :per-page="10"
      striped
      hover
      :total="partnerMasterList.pageTotal"
      :update="updatePartnerStatus"
      :edit="editPartnerItem"
      :delete="deleteMasterPopup"
      :sortTable="sortTable"
      :isBusy="isBusy"
      :pagination="pagination"
      :countPerPage="currentPage"
    ></c-table>
      <nav>
      <div class="pagination-module">
        <b-pagination
          :total-rows="partnerMasterList.pageTotal"
          @change="pagination"
          :per-page="10"
          v-model="currentPage"
          :prev-text="$t('FORWARD')"
          :next-text="$t('NEXT')"
        />
      </div>
    </nav>

    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
      <p class="my-2 wrapText">
        {{ selectedItemFromTable.name }} {{ $t("DELETECONFIRMATIONCOMMOM") }}
      </p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-danger"
            class="buttons-align-right"
            size="sm"
            @click="deleteItem()"
            >{{ $t("DELETE") }}</b-button
          >
          <b-button
            variant="outline-secondary"
            size="sm"
            class="buttons-align-right"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-Status" hide-footer ref="vuemodal" @hidden="close">
      <template v-slot:modal-title>{{
        $t("STATUSCHANGECONFIRMATION")
      }}</template>
      <p>{{ $t("CHANGESTATUSCONFIRMATION") }}</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="partnerStatusChange()"
            >{{ $t("SUBMIT") }}</b-button
          >
          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="close"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import cTable from "@/components/Table.vue";
import { mapGetters } from "vuex";
import { checkPermisssion } from "@/shared/utils.js";

import {
  PARTNER_MASTER_LIST,
  DELETE_PARTNET_MASTER,
  UPDATE_PARTNER_STATUS
} from "@/store/actions.type";

export default {
  name: "partnerList",
  data() {
    return {
      searchKeyword: "",
      renderComponent: true,
      checkPermisssion: checkPermisssion,
      tableHeader: [],
      selectedItemFromTable: "",
      isLoading: "",
      sortField: "",
      sortDirection: "",
      isBusy: true,
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters(["partnerMasterList", "caregory"])
  },
  methods: {
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    deleteMasterPopup(row) {
      this.selectedItemFromTable = row;
      this.$bvModal.show("modal-delete");
    },
    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    editPartnerItem(row) {
      this.$router.push({
        name: "editpartner",
        params: { id: row.id }
      });
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    async partnerStatusChange() {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let selectedItemId = _.get(this.selectedItemFromTable, "id", 0);
      this.$bvModal.hide("modal-Status");

      if (selectedItemId) {
        let status = _.get(this.selectedItemFromTable, "status", "");
        let data = await this.$store
          .dispatch(UPDATE_PARTNER_STATUS, {
            id: selectedItemId,
            status: status == "active" ? "inactive" : "active"
          });
        this.isLoading.hide();
            if (_.get(data, "status",false)) {
              this.$toast.success({
                message: _.get(data, "message", '')
              });
              this.pagination(this.currentPage);
            } else {
              this.$toast.error({
                message:  _.get(data, "message", '')
              });
            }
      } else {
        this.$bvModal.hide("modal-Status");
        this.isLoading.hide();
      }
    },
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    updatePartnerStatus(row) {
      this.selectedItemFromTable = row;
      this.$bvModal.show("modal-Status");
    },
    /**
     * Delete function for table Row
     * Input @param {Number} userID selected Row ID
     * Output @param {Boolean}   data.status  Boolean status Api call
     */
    async deleteItem() {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      let data = await this.$store
        .dispatch(DELETE_PARTNET_MASTER, { id: this.selectedItemFromTable.id });
        this.isLoading.hide();
          if (_.get(data,"status", false)) {
            this.$toast.success({
              message: _.get(data, "message",'')
            });
            this.isBusy = true;
            if(this.partnerMasterList.list.length === 1)
            {
                this.pagination(1);
            }else{
              this.pagination(this.currentPage);
            }
          } else {
            this.$toast.error({
              message: _.get(data, "message",'')
            });
          }
      
      this.$bvModal.hide("modal-delete");
    },
    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
     this.pagination(this.currentPage);
    },
    /* Pagintaion */
    pagination(page) {
      this.currentPage = page;
      this.isBusy = true;
      this.$store
        .dispatch(PARTNER_MASTER_LIST, {
          search_query: this.searchKeyword,
          page: this.currentPage,
          field: this.sortField,
          sort: this.sortDirection
        })
        .then(data => {
          this.isBusy = false;
        });
    },
    /*Rerender Fuction */
    close() {
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },

    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      this.pagination(1);
    }
  },
  components: { cTable },
  created() {
    this.$toast.removeAll();
    this.$store
      .dispatch(PARTNER_MASTER_LIST, {
        field: "id",
        sort: "desc",
      })
      .then(dat => {
        this.isBusy = false;
      });

    this.tableHeader = [
      { key: "id", label: this.$t("ID"), sortable: true, class: "text-left" },
      {
        key: "name",
        label: this.$t("PARTNERCATEGORYNAME"),
        sortable: true,
        class: "text-left"
      }
    ];
    if (checkPermisssion("MASTER", "MASTER_PARTNER_CATEGORY")) {
      // allowing users to do actions on table if they have Permission
      this.tableHeader.push({
        key: "status",
        label: this.$t("STATUS"),
        sortable: false
      });
      this.tableHeader.push({
        key: "actions",
        label: this.$t("ACTION"),
        sortable: false
      });
    } else {
      this.tableHeader.push({
        //disabled the actions on table if they dont have Permission
        key: "status_disable",
        label: this.$t("STATUS"),
        sortable: false
      });
    }
  }
};
</script>
<style scoped>
.header{
  margin-top: 14px;
}
.add-button{
  font-size: 17px;
  margin-top: 14px;
  margin-left:20px;
}
.search-box{
  width:200px;
  margin:10px 0px;
}
</style>